import React, { FunctionComponent } from "react";
import { theme } from "/src/assets/theme";
import { makeStyles } from "@mui/styles";
import { Link } from "@mui/material";
import cs from "classnames";
import { DirectionsRun, Group, LocationCity } from "@mui/icons-material";

export interface BadgeElementProps {
  type: ParticipantBadgeType;
}

export interface ParticipantBadgeProps extends BadgeElementProps {
  value: string;
  link?: string;
  className?: string;
}

export enum ParticipantBadgeType {
  CITY,
  COACH,
  LOCATION,
}

export const ParticipantBadge: FunctionComponent<ParticipantBadgeProps> = ({
  type,
  value,
  link,
  className,
}) => {
  const classes = useStyles({ type });

  return (
    <Link
      className={cs(classes.container, className)}
      href={link}
      onClick={(e: any) => {
        if (link) e.stopPropagation();
      }}
    >
      {type === ParticipantBadgeType.CITY && (
        <LocationCity sx={{ width: 16, height: 16, paddingRight: 0.5 }} />
      )}
      {type === ParticipantBadgeType.COACH && (
        <DirectionsRun sx={{ width: 16, height: 16, paddingRight: 0.5 }} />
      )}
      {type === ParticipantBadgeType.LOCATION && (
        <Group sx={{ width: 16, height: 16, paddingRight: 0.5 }} />
      )}
      {value}
    </Link>
  );
};

const useStyles = makeStyles({
  container: (props: BadgeElementProps) => {
    const styles: any = {
      padding: "0.25rem 0.5rem",
      display: "flex",
      borderRadius: "10px",
      textDecoration: "none",
      alignItems: "center",
      fontWeight: 400,
      fontSize: "0.8rem",
    };

    if (props.type === ParticipantBadgeType.LOCATION) {
      styles.background = theme.lightSecondaryColor;
      styles.color = theme.secondaryColor;
    }

    if (props.type === ParticipantBadgeType.COACH) {
      styles.background = theme.greenSurfaceColor;
      styles.color = theme.lightGreenColor;
    }

    if (props.type === ParticipantBadgeType.CITY) {
      styles.background = theme.lightPurpleColor;
      styles.color = theme.purpleColor;
    }

    return styles;
  },
});
